import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from '../shadcn-ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn-ui/select';
import { Button } from '../shadcn-ui/button';
import { Plus } from 'lucide-react';
import { Label } from '../shadcn-ui/label';
import { Input } from '../shadcn-ui/input';
import { PhoneInput } from '../shadcn-ui/phone-input';
import { toast } from 'sonner';
import { addUser } from '@/network/auth.service';

const roles = ['Admin', 'Processor'];

const AddUserDialog = () => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    role: '',
    phone: '',
  });

  const resetForm = () => {
    setFormData({ fullName: '', role: '', phone: '' });
  };

  const handleAddUser = async () => {
    if (!formData.fullName || !formData.role || !formData.phone) {
      // replace with toast if you want
      toast.error('Please fill all fields');
      return;
    }

    const payload = {
      fullname: formData.fullName,
      client_role: formData.role.toUpperCase(),
      phone_number: formData.phone,
    };

    setLoading(true);

    try {
      const { data } = await addUser(payload);
      toast.success(data?.message);
    } catch (error) {
      toast.error('Error adding user:', error);
    }

    resetForm();
    setIsAddOpen(false);
    setLoading(false);
  };

  return (
    <Dialog open={isAddOpen} onOpenChange={setIsAddOpen}>
      <DialogTrigger asChild>
        <Button className="inline-flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add User
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add User</DialogTitle>
          <DialogDescription>This is just a skeleton UI for creating a user.</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Full Name</Label>
            <Input
              placeholder="Enter full name"
              value={formData.fullName}
              onChange={e => setFormData(prev => ({ ...prev, fullName: e.target.value }))}
              disabled={loading}
            />
          </div>

          <div className="space-y-2">
            <Label>Role</Label>
            <Select
              value={formData.role}
              onValueChange={value => setFormData(prev => ({ ...prev, role: value }))}
              disabled={loading}
            >
              <SelectTrigger>
                <SelectValue placeholder="Choose a role" />
              </SelectTrigger>
              <SelectContent>
                {roles.map(role => (
                  <SelectItem key={role} value={role}>
                    {role}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Phone</Label>
            <PhoneInput
              value={formData.phone}
              onChange={value => {
                setFormData({ ...formData, phone: value });
              }}
              defaultCountry="IN"
              placeholder="Enter phone number"
              disabled={loading}
            />
          </div>
        </div>

        <DialogFooter className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={() => {
              resetForm();
              setIsAddOpen(false);
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button onClick={handleAddUser} disabled={loading}>
            {loading ? 'Adding...' : 'Add User'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserDialog;
